import React from 'react'
import Navegacion from '../Navegacion/Navegacion'
import PiePagina from '../PiePagina/PiePagina'

export default function Contenido(props) {
  return (
    <div id='content-wrapper' className='d-flex flex-column'>
      <div id='content'>
        <Navegacion onToggle={props.handleToggle} />

        <div className='container-fluid'>
          <h1 className='h3 mb-4 text-gray-800'>{props.titulo}</h1>

          {props.children}
        </div>
      </div>

      <PiePagina />
    </div>
  )
}
